:host {
  display: flex;
  flex-direction: row;
  cursor: pointer;
  border: 0;

  .quick-link {
    border-bottom-color: transparent;
    color: var(--sdx-color-gray);
    text-decoration: none !important;
    font-size: 14px !important;
    line-height: 1.5 !important;
    display: flex;
    align-items: baseline;
  }

  .quick-link__icon {
    margin-right: 6px;
  }
}

:host(:hover) {
  .quick-link {
    color: var(--sdx-color-int-blue);
  }
}

:host(.focus) {
  .quick-link {
    color: var(--sdx-color-int-blue);
  }
}

.text-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.quick-link__text {
  margin-right: 6px;
}

.breadcrumbs {
  display: flex;
  color: var(--sdx-color-gray-tint-4);

  // <ul> reset
  list-style: none;
  padding: 0;
  margin: 0;
}

.breadcrumbs > *:after {
  content: ">";
  padding: 0 0.25em;
}

.breadcrumbs > *:last-child:after {
  content: "";
  padding: 0;
}
